(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/sportkryss/assets/javascripts/sportkryss.js') >= 0) return;  svs.modules.push('/components/sport/sportkryss/assets/javascripts/sportkryss.js');

'use strict';

var svs = svs || {};

(function(svs) {
  svs = svs || {};
  svs.sport = svs.sport || {};
  svs.sport.sportkryss = svs.sport.sportkryss || {};

  svs.sport.sportkryss.Sportkryss = Marionette.View.extend({
    template: function(data) {
      return svs.sport.sportkryss.templates.sportkryss(data);
    },
    templateContext: function() {
      return {
        fixedAmount: this.options && this.options.fixedAmount
      };
    },
    id: 'sportkryss',
    isFirstRender: true,
    log: new svs.core.log.Logger('svs.sport.sportkryss.Sportkryss'),

    defaultOptions: {
      toggleButtonCSSClass: 'btn-toggle-default',
      buttonCSSClass: 'btn-transparent-default'
    },

    ui: {
      number: '#sportkryss-number',
      price: '.js-sportkryss-price',
      huxflux: '.js-hux-flux',
      helpDialog: '.js-help-dialog-sportkryss',
      inputHolder: '.js-input-holder'
    },

    events: {
      'keyup @ui.number': 'onSportkryssNumberChange',
      'focusout @ui.number': 'onLeaveSportkryssNumber',
      'click @ui.price': 'onSportkryssAmountChange',
      'click @ui.huxflux': 'doHuxFlux',
      'click @ui.helpDialog': 'helpDialogSportKryss'
    },

    onSportkryssChanged: function(bet, isValid, sportkryssNumber) {
      this.log.error(
        'Sportkryss.onSportkryssChange not provided',
        JSON.stringify(bet),
        isValid,
        sportkryssNumber
      );
      throw new Error('No onSportkryssChanged method provided!');
    },

    initialize: function(options) {
      this.log.debug('initialize');
      this.$el.addClass('sportkryss');
      this.newErrorBehaviour = options.newErrorBehaviour || false;
      this.helpDialogTitle = options.helpDialogTitle;
      this.helpDialogBody = options.helpDialogBody;

      this.showHuxFlux = false;

      if (this.model instanceof Backbone.Model) {
        this.onSportkryssChanged = function() {
          this.model.trigger('onSportkryssChanged');
        };
      } else {

        this.onSportkryssChanged = options.onSportkryssChanged;

        if (this.model) {
          this.model = new Backbone.Model(jQuery.extend(true, {}, this.model));
        } else {
          this.model = new Backbone.Model();

          this.model.set(
            this.createNewSportkryssWager(options.sportkryssNumber),
            { silent: true }
          );
        }
      }

      this.model.set({
        toggleButtonCSSClass:
          options.toggleButtonCSSClass || this.defaultOptions.headerClass,
        buttonCSSClass:
          options.buttonCSSClass || this.defaultOptions.buttonCSSClass,
        defaultSportkryssAmount: options.defaultSportkryssAmount || '10',
        showErrorMessage: false,
        sportkryssAmounts: [
          { value: '0', string: 'Nej' },
          { value: '10', string: '10 kr' },
          { value: '20', string: '20 kr' },
          { value: '30', string: '30 kr' }
        ],
        showHelpText: true,
        alwaysShowHuxFlux: true
      });
    },

    onBeforeRender: function() {
      var currSportkryssNr;
      var isValidSportkryss = false;
      if (this.model.get('jokerBoards')) {
        currSportkryssNr = this.model.get('jokerBoards')[0].boardData.join('');
        isValidSportkryss =
          this.model.get('jokerBoards')[0].boardData.length === 7;
      }
      this.model.set(
        {
          sportkryssNumber: currSportkryssNr,
          currentSportkryssAmount: svs.utils.format
            .CurrencyFromJupiterString(this.model.get('betAmountSalesGroup1'))
            .toString(),
          isValid: isValidSportkryss
        },
        { silent: true }
      );
    },

    onRender: function() {
      if (this.isFirstRender) {
        this.onSportkryssNumberChange({
          currentTarget: {
            value: this.el.getElementsByClassName('js-input-sportkryss')[0]
              .value
          }
        });

        if (!this.model.get('alwaysShowHuxFlux')) {
          var self = this;
          if (this.isFirstRender) {
            if (this.model.get('currentSportkryssAmount') === '0') {
              self.ui.inputHolder.hide();
            }
          }
          this.ui.price.parent().on('click', 'input', function(e) {
            var value = $(e.currentTarget).attr('value');
            if (value === '0') {
              self.ui.inputHolder.hide();
            } else {
              self.ui.inputHolder.show();
            }
          });
        }
      }
      this.delegateEvents();

      this.isFirstRender = false;
    },

    onSportkryssNumberChange: function(ev) {
      var item = $('#sportkryss-number');
      if (item[0]) {
        var isValid = this.validate(item[0]);
        this.model.set('isValid', isValid);
        if (this.newErrorBehaviour) {
          $('.js-input-holder').toggleClass('error', !isValid);
          $('.js-sportkryss-error').toggleClass('hide', isValid);
        }
        $('.js-input-holder').toggleClass('error', !isValid);
        if (this.model.get('jokerBoards')) {
          if (
            ev.currentTarget.value !==
            this.model.get('jokerBoards')[0].boardData.join('')
          ) {
            this.model.get('jokerBoards')[0].boardData = ev.currentTarget.value.split('');

            _.map(this.model.get('jokerBoards')[0].boardData, function(num) {
              return parseInt(num, 10);
            });

            if (isValid) {
              $('.js-sportkryss-error').toggleClass('hide', isValid);
              this.trigger('sportkryssChangeSize');
            }
            this.onSportkryssChanged(
              this.returnWager(),
              isValid,
              this.model.get('jokerBoards')[0].boardData.join('')
            );
            this.model.trigger('change', this.model);
          }
        }
      }
    },

    onLeaveSportkryssNumber: function(ev) {
      this.log.debug('onLeaveSportkryssNumber ' + !this.model.get('isValid'));

      var item = $('#sportkryss-number');
      if (item[0]) {
        var isValid = this.validate(item[0]);
        this.model.set('isValid', isValid);
        $('.js-input-holder').toggleClass('error', !isValid);
        $('.js-sportkryss-error').toggleClass('hide', isValid);


        if (this.model.get('jokerBoards')) {
          this.model.get('jokerBoards')[0].boardData = ev.currentTarget.value.split('');

          _.map(this.model.get('jokerBoards')[0].boardData, function(num) {
            return parseInt(num, 10);
          });
          this.onSportkryssChanged(
            this.returnWager(),
            isValid,
            this.model.get('jokerBoards')[0].boardData.join('')
          );
        }
        this.trigger('sportkryssChangeSize');

        this.model.trigger('change', this.model);
      }
    },

    onSportkryssAmountChange: function(ev) {
      var value = ev.target.value;
      var self = this;

      if (value) {
        this.model.set(
          'betAmountSalesGroup1',
          svs.utils.format.CurrencyAsJupiterString(value)
        );
        this.model.set('rowPriceMulti', value / 10);
        if (value === '0') {
          this.model.set('isValid', true);
        } else {
          var item = $('#sportkryss-number');
          if (item[0]) {
            var isValid = this.validate(item[0]);
            this.model.set('isValid', isValid);
          }
        }
        $('.js-input-sportkryss').prop('disabled', value === '0');
        $('.js-hux-flux').prop('disabled', value === '0');

        var returnObject;
        if (value !== '0') {
          returnObject = this.returnWager();
        }

        window.requestIdleCallback(function() {
          var currSportkryssNumber;
          if (self.model.get('jokerBoards')) {
            currSportkryssNumber = self.model
              .get('jokerBoards')[0]
              .boardData.join('');
          }
          self.onSportkryssChanged(
            returnObject,
            self.model.get('isValid'),
            currSportkryssNumber
          );
        });
      }
    },

    validate: function(item) {
      return /^[0-9]{7}$/.test(item.value);
    },

    doHuxFlux: function() {
      var sportkryssNumber = this.generateSportkryssNumber();
      this.model.sportkryssNumber = sportkryssNumber.join('');
      this.model.set('isValid', true, {
        silent: !this.newErrorBehaviour
      });
      $('.js-input-holder').toggleClass('error', false);
      $('.js-sportkryss-error').toggleClass('hide', true);
      this.trigger('sportkryssChangeSize');

      if (this.model.get('jokerBoards')) {
        this.model.get('jokerBoards')[0].boardData = sportkryssNumber;
      }
      this.el.getElementsByClassName('js-input-sportkryss')[0].value = this.model.sportkryssNumber;

      if (this.model.get('jokerBoards')) {
        this.onSportkryssChanged(
          this.returnWager(),
          this.model.get('isValid'),
          this.model.get('jokerBoards')[0].boardData.join('')
        );
      }
    },

    generateSportkryssNumber: function() {
      var jn = [];
      for (var i = 0; i < 7; i++) {
        jn.push(svsRandom.getRandomInt(0, 9));
      }

      return jn;
    },

    createNewSportkryssWager: function(defaultSportkryssNumber) {
      var betAmount = this.model.get('defaultSportkryssAmount') ?
          this.model.get('defaultSportkryssAmount') :
          0;
      var sportkryssNumber = null;
      if (defaultSportkryssNumber) {
        sportkryssNumber = defaultSportkryssNumber.split('');
      }
      return {
        productId: 'SPORTJOKER',
        drawNum: 0,
        numDraws: 1,
        betAmountSalesGroup1: svs.utils.format.CurrencyAsJupiterString(betAmount),
        betAmountSalesGroup2: '0,00',
        rowPriceMulti: betAmount > 0 ? betAmount / 10 : 1,
        betProperties: [],
        jokerBoards: [
          {
            systemType: ['SROW'],
            numSelections: 7,
            participation: 0,
            rowPriceMulti: 1,
            boardData: sportkryssNumber || this.generateSportkryssNumber()
          }
        ]
      };
    },

    returnWager: function() {
      var returnObject = {
        productId: this.model.get('productId'),
        drawNum: this.model.get('drawNum'),
        numDraws: this.model.get('numDraws'),
        betAmountSalesGroup1: svs.utils.format.CurrencyAsJupiterString(this.model.get('betAmountSalesGroup1')),
        betAmountSalesGroup2: svs.utils.format.CurrencyAsJupiterString(this.model.get('betAmountSalesGroup2')),
        rowPriceMulti: this.model.get('rowPriceMulti'),
        betProperties: this.model.get('betProperties'),
        jokerBoards: this.model.get('jokerBoards')
      };
      return returnObject;
    },

    helpDialogSportKryss: function(e) {
      if (this.helpDialogTitle && this.helpDialogBody) {
        var _dialog = new svs.components.dialog.Contextual({
          branding: svs.components.dialog.branding.SPORT,
          attachTo: $(e.currentTarget),
          zIndex: 1400,
          title: this.helpDialogTitle,
          message: [
            {
              type: svs.components.dialog.message.TEXT,
              text: this.helpDialogBody
            }
          ]
        });
        svs.components.dialog.api.add(_dialog);
      }
    }
  });
})(svs);


 })(window);